module.exports = __webpack_public_path__ + "img/small-mail-open-icon.a134736d.svg";